import { Component, OnInit, ComponentFactoryResolver, Injector, Input, ViewChild, ElementRef, HostBinding, AfterViewInit, NgZone, Optional, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExpressionService, InjectedType, ExprEditMode } from '@gsp-svc/expression';
import { HttpService, SessionService } from '@ecp-caf/caf-common';
import { BsModalService } from '@farris/ui-modal';
import { CommonComponentUiRTService, SelectorResult } from '@gsp-cmp/ccmp-ui';
import { SelectMetadataRTComponent, Metadata4RefDto, MetadataDto } from '@gsp-lcm/metadatart-selector';
import { GspComponent } from '@gsp-cmp/common-component';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { of, forkJoin, Observable, throwError } from 'rxjs';
import { RowEditParam } from '@farris/ui-datagrid/lib/types';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { LookupGridComponent } from '@farris/ui-lookup';
import { ComponentPerformerService } from './component-performer.service';
import { WebServiceParameter, ParameterFetchValueMode, HelpFetchValueSetting } from '@gsp-cmp/wscmp-models';
import { ComponentPerformer, ActualParameter } from './component-performer.entity';
import { ProcessDeUtil } from '../../../../domain/process-de-util';
import { catchError } from 'rxjs/operators';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';
@Component({
  selector: 'app-component-performer',
  templateUrl: './component-performer.component.html',
  styleUrls: ['./component-performer.component.scss'],
  providers: [
    ComponentPerformerService,
     WfLocalePipe
  ]
})
export class ComponentPerformerComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  private componentPerformer: ComponentPerformer;
  @ViewChild(DatagridComponent) grid: DatagridComponent;
  @ViewChild(LookupGridComponent) lookup: LookupGridComponent;
  @ViewChild('inputGroup') inputGroup: ElementRef;
  showClearButton = false;
  helpId='';
  lookupDisplayText='';
  @Input()
  set component(cmp: ComponentPerformer) {
    if (cmp && cmp.methodCode) {
      this.service.getHelpMetaData(cmp.metadataId, '').subscribe(re => {
        const c = JSON.parse(re.content);
        const operation = c.operations.find(o => o.code === cmp.methodCode);
        if (operation) {
          cmp.actualParameters = cmp.actualParameters.map(a => {
            const p = operation.parameters.find(i => i.code === a.code);
            if (p) {
              return {
                code: a.code,
                name: p.name,
                value: a.value,
                valueText: a.valueText ? a.valueText : a.value,
                description: p.description,
                tag: a.tag,
                fetchValueMode: p.fetchValueMode,
                fetchValueSetting: p.fetchValueSetting
              };
            } else {
              throw new Error(this.localePipe.transform('component.componentPerformer.componentMethod'));
            }
          });
          this.componentPerformer = cmp;
        } else {
          throw new Error(this.localePipe.transform('component.componentPerformer.methodNotExist'));
        }
      });
    } else {
      this.componentPerformer = new ComponentPerformer();
    }
  }
  get component() {
    return this.componentPerformer;
  }

  curParameter: ActualParameter;
  columns = [
    { field: 'code', width: 60, title: this.localePipe.transform('component.componentPerformer.code') },
    { field: 'name', width: 60, title: this.localePipe.transform('component.componentPerformer.name') },
    { field: 'description', width: 60, title: this.localePipe.transform('component.componentPerformer.description'), showTips: true },
    {
      field: 'valueText', width: 100, title: this.localePipe.transform('component.componentPerformer.valueText'),
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.showExprHelp(e);
          },
          clear: (e) => {
            // 清理valueText，也应该清理value
            e.rowData.value = '';
            for (const p of this.component.actualParameters) {
              if (p.code === e.rowId) {
                p.value = '';
              }
            }
          }
        }
      }
    }
  ];
  helpInfo = {
    helpId: '',
    su: '',
    columns: [],
    displayType: 'List',
    items: [],
    pageInfo: {
      pageIndex: 1,
      pageList: [10, 20, 30, 50],
      pageSize: 20
    },
    search: { category: 'all'},
    title: this.localePipe.transform('component.componentPerformer.help'),
    total: 100,
    fieldInfo: {
      idField: 'id',
      textField: 'name',
      valueField: 'id'
    }
  };
  cell: any;
  constructor(
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private sessionSrc: SessionService,
    private modalService: BsModalService,
    private componentService: CommonComponentUiRTService,
    private ngZone: NgZone,
    private service: ComponentPerformerService,
    private util: ProcessDeUtil,
    private http: HttpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }
  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }

  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }
  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }

  selectChanged(event) {
    this.curParameter = event.data;
  }
  beforeEdit = (param: RowEditParam) => {
    const rowData = param.rowData as any;
    this.curParameter = rowData;
    switch (rowData.fetchValueMode) {
      case ParameterFetchValueMode.express:
        param.column.editor = {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              e.formControl.setValue(e.instance.value ? e.instance.value : '');
              this.showExprHelp(e);
            },
            clear: (e) => {
              // 清理valueText，也应该清理value
              e.rowData.value = '';
              for (const p of this.component.actualParameters) {
                if (p.code === e.rowId) {
                  p.value = '';
                }
              }
            }
          }
        };
        break;
      case ParameterFetchValueMode.none:
        param.column.editor = {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              e.formControl.setValue(e.instance.value ? e.instance.value : '');
              this.showExprHelp(e);
            },
            clear: (e) => {
              // 清理valueText，也应该清理value
              e.rowData.value = '';
              for (const p of this.component.actualParameters) {
                if (p.code === e.rowId) {
                  p.value = '';
                }
              }
            }
          }
        };
        break;
      case ParameterFetchValueMode.const:
        param.column.editor = { type: EditorTypes.TEXTBOX, options: {} };
        break;
      case ParameterFetchValueMode.enum:
        param.column.editor = { type: EditorTypes.TEXTBOX, options: {} };
        break;
      case ParameterFetchValueMode.help:
        param.column.editor = {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              this.cell = e;
              this.helpInfo.helpId = (rowData.fetchValueSetting as HelpFetchValueSetting).helpId;
              this.helpInfo.su = (rowData.fetchValueSetting as HelpFetchValueSetting).serviceUnit;
              this.helpInfo.pageInfo = {
                pageIndex: 1,
                pageList: [10, 20, 30, 50],
                pageSize: 20
              };
              this.helpInfo.search = { category: 'all' };
              this.getHelpInfo();
            },
            clear: (e) => {
              // 清理valueText，也应该清理value
              e.rowData.value = '';
              for (const p of this.component.actualParameters) {
                if (p.code === e.rowId) {
                  p.value = '';
                }
              }
            }
          }
        };
        break;
    }
    return of(true);
  }
  afterEdit = (rowIndex: number, rowData: any, column?: DataColumn) => {
    return of(true);
  }

  endEdit(e: any) {
    // 文本框编辑同时修改value
    if (e.rowData.fetchValueMode === ParameterFetchValueMode.const || e.rowData.fetchValueMode === ParameterFetchValueMode.enum) {
      this.component.actualParameters[e.rowIndex].value = this.component.actualParameters[e.rowIndex].valueText;
    }
  }

  clear() {
    this.componentPerformer.name = '';
    this.componentPerformer.metadataId = '';
    this.componentPerformer.methodCode = '';
    this.componentPerformer.methodName = '';
    this.componentPerformer.condition = '';
    this.componentPerformer.actualParameters = new Array();
  }

  selectComponent() {
    const compFactory = this.resolver.resolveComponentFactory(SelectMetadataRTComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.typeList = 'WebServiceComponent'; // 目前只能根据元数据类型过滤，后续添加标签过滤
    compRef.instance.selectedMetadata.subscribe(($event: Metadata4RefDto) => {
      try {
        const meta: MetadataDto = $event.metadata;
        this.openComponentSelectorNew(meta.id, this.sessionSrc.getUserSessionId());
      } catch {
        console.log('$event', $event);
        throw new Error(this.localePipe.transform('component.componentPerformer.errorObtaining') + $event);
      }
    });

    const modalConfig = {
      title: this.localePipe.transform('component.componentPerformer.componentSelection'),
      width: 980,
      height: 548,
      showButtons: false
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe($event => dialog.close());
  }
  private openComponentSelectorNew(metadataId: string, sessionId: string) {
    this.componentService.openSelector(metadataId, sessionId).subscribe(
      (selectorResult: SelectorResult) => {
        selectorResult.confirmEvent.subscribe(
          (result: GspComponent) => {
            if (result) {
              this.component.name = result.name;
              this.component.metadataId = result.id;
              this.component.methodCode = result.operations[0].code;
              this.component.methodName = result.operations[0].name;
              this.component.actualParameters = [];

              if (result.operations[0].parameters && result.operations[0].parameters.length > 0) {
                this.component.actualParameters = result.operations[0].parameters
                  .map((p: WebServiceParameter) => (
                    {
                      code: p.code,
                      name: p.name,
                      value: '',
                      valueText: '',
                      description: p.description,
                      fetchValueMode: p.fetchValueMode,
                      fetchValueSetting: p.fetchValueSetting
                    }) as any);
              }
            }
          });
      });
  }
  showExprHelp(e: any) {
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.setEditPattern(ExprEditMode.Advanced); // 默认打开高级表达式编辑器
    this.expr.addExpressionText(e.instance.value);
    this.expr.buildExpression().then((d: string) => {
      if (d) {
        e.formControl.setValue(d);
        e.instance.cd.detectChanges();
        e.rowData.value = d;
        for (const p of this.component.actualParameters) {
          if (p.code === e.rowId) {
            p.value = d;
          }
        }
      }
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  getPerformers() {
    this.grid.endCellEdit();
    console.log(this.component);
    return this.component;
  }

  private getHelpInfo() {
    // 2023年6月29日 此处获取帮助的结构
    this.service.getHelpMetaData(this.helpInfo.helpId, this.helpInfo.su).subscribe(re => {
      if (re) {
        const meta = re;
        const help = JSON.parse(meta.content) as any;
        this.helpInfo.columns = help.dataSource.columns;
        this.helpInfo.displayType = help.displayType;
        this.helpInfo.fieldInfo = {
          idField: help.idField,
          valueField: help.valueField,
          textField: help.textField
        };
      } else {
        throw new Error(this.localePipe.transform('component.componentPerformer.metadataNotExist'));
      }
    })
    // 打开帮助
    this.lookup.showDialog();
  }

  /**
   * 帮助前事件
   * @param e
   * @returns
   */
  onDictPicking = (e) => {
    e.instance.http = {
      getData: (url:string, params: any): Observable<any>  => {
        const _url = `/api/runtime/bcc/v1.0/help/data/${this.helpInfo.helpId}`;
        params = Object.assign(params || {}, { withSpecificField: true });
        return this.http.put(_url, params).pipe(
            catchError((e) => {
                if (e.error && e.error.innerMessage && e.error.innerMessage.indexOf('Could not find metadata') > -1) {
                    e.error.Message = this.localePipe.transform('component.componentPerformer.serverSideNotFound');
                }
                return throwError(e);
            })
        )
      }
    }
    return of(true);
  }

  dictPicked = (rowData) => {
    if (this.cell) {
      this.cell.formControl.setValue(this.util.getValue(rowData, this.helpInfo.fieldInfo.textField));
      this.cell.instance.cd.detectChanges();
      this.cell.rowData.value = this.util.getValue(rowData, this.helpInfo.fieldInfo.valueField);
      for (const p of this.component.actualParameters) {
        if (p.code === this.cell.rowId) {
          p.value = this.util.getValue(rowData, this.helpInfo.fieldInfo.valueField);
        }
      }
      return of(true);
    }
  }
  pagerChanged(data: any) {
    if (data) {
      this.helpInfo.pageInfo.pageIndex = data.pageIndex;
      this.helpInfo.pageInfo.pageSize = data.pageSize;
      this.service.getLookUpData(this.helpInfo.helpId, this.helpInfo.su,
        this.helpInfo.pageInfo.pageIndex, this.helpInfo.pageInfo.pageSize, this.helpInfo.search)
        .subscribe(re => {
          this.helpInfo.items = re.items;
          this.helpInfo.title = re.title;
          this.helpInfo.total = re.total;
          this.lookup.loadData(re);
        });
    }
  }
  search(data) {
    console.log(data);
    this.helpInfo.search = { category: 'search' };
    if (data) {
      const searchInfo = {
        searchField: data.field || data.search.field,
        searchValue: data.value || data.search.value
      };
      this.helpInfo.search = Object.assign(this.helpInfo.search, searchInfo);
      this.service.getLookUpData(this.helpInfo.helpId, this.helpInfo.su,
        this.helpInfo.pageInfo.pageIndex, this.helpInfo.pageInfo.pageSize, this.helpInfo.search)
        .subscribe(re => {
          this.helpInfo.items = re.items;
          this.helpInfo.title = re.title;
          this.helpInfo.total = re.total;
          this.lookup.loadData(re);
        });
    }
  }
}
